module.exports = __webpack_public_path__ + "static/media/lol-diamond.86e484e0.png";